export function imageLoader(pdf, image, base64=false) {
    pdf.docDefinition.images[image.imageGarbageCollectionID] =
        base64 ?
            image.base64
            :
            image.link;
}
